import * as t from 'io-ts';
import { pipe } from 'rxjs';
import { filter } from 'rxjs/operators';
/**
 * Pipeable operator accepting a codec from io-ts and filtering out any input
 * not matching it
 */
export const filterByCodec = <C extends t.Mixed>(codec: C) =>
  pipe(filter((input): input is t.OutputOf<C> => codec.is(input)));
